import { resume, resumeAnchor } from "./resume";
import { contact } from "./search";

// The home folder in Ghostty: the resume as files. A file has `lines`, what `cat` prints, and
// `anchor`, the spot in the resume `open` shows it at in Notes. A folder has `items`. A line is a
// string, or a list of pieces: strings and { text, tone, href } (see utils/shell.js).

const jobFile = (job) => `${job.company.split(",")[0].toLowerCase().replace(/\s+/g, "-")}.md`;
const projectFile = (p) => `${p.name.split(" ")[0].toLowerCase()}.md`;
const pad = (labels) => {
  const width = Math.max(...labels.map((l) => l.length)) + 2;
  return (label) => label.padEnd(width);
};

const [latest] = resume.experience;
const [school] = resume.education;
const certPad = pad(["Education", "Certifications"]);

const about = {
  anchor: null,
  lines: [
    [{ text: resume.name, tone: "bold" }],
    resume.role,
    "",
    "I build backend services in Go, TypeScript and Kotlin, web apps in React and Next.js, and the " +
      `Kubernetes infrastructure they run on. Most recently I worked on core banking services at ${
        latest.company.split(",")[0]
      }.`,
    "",
    `${certPad("Education")}${school.degree}, ${school.school.match(/\((\w+)\)/)[1]}, ${school.location} (${school.date})`,
    ...resume.certifications.map((c, i) => `${certPad(i ? "" : "Certifications")}${c.name}`),
  ],
};

const skillPad = pad(resume.skills.map((s) => s.label));
const skills = {
  anchor: resumeAnchor("Technical skills"),
  lines: resume.skills.map((s) => [{ text: skillPad(s.label), tone: "bold" }, s.value]),
};

const contactPad = pad(resume.contacts.map((c) => c.label));
const contactFile = {
  anchor: null,
  lines: resume.contacts.map((c) => [contactPad(c.label), { text: c.text, href: c.href }]),
};

const job = (j) => ({
  anchor: resumeAnchor(j.company),
  lines: [`# ${j.role}, ${j.company}`, j.dates, "", ...j.points.map((p) => `- ${p}`)],
});

const project = (p) => ({
  anchor: resumeAnchor(p.name),
  lines: [`# ${p.name}`, p.date, "", p.description],
});

export const HOME = {
  items: {
    "about.txt": about,
    "contact.txt": contactFile,
    experience: { items: Object.fromEntries(resume.experience.map((j) => [jobFile(j), job(j)])) },
    projects: { items: Object.fromEntries(resume.projects.map((p) => [projectFile(p), project(p)])) },
    "skills.txt": skills,
  },
};

// `experience` and `projects`: the short versions, pointing at the files with the details.
export const EXPERIENCE = [
  ...resume.experience.map((j) => [{ text: j.dates.padEnd(21), tone: "dim" }, `${j.role}, ${j.company}`]),
  "",
  [{ text: `For the details: cat experience/${jobFile(latest)}`, tone: "dim" }],
];

export const PROJECTS = resume.projects.flatMap((p, i) => [
  ...(i ? [""] : []),
  [
    { text: p.name, tone: "bold" },
    { text: `  ${p.date}`, tone: "dim" },
  ],
  p.description,
]);

// What `open` takes besides files: Sylvester's links.
export const LINKS = {
  email: contact("Email").href,
  linkedin: contact("LinkedIn").href,
  website: contact("Website").href,
};

export const CONTACT_HINT = [{ text: "open email, open linkedin or open website to get in touch.", tone: "dim" }];
